import { useEffect, useRef } from "react";

import { type NotificationContentType } from "@vega-api/generated/types/notificationContentType";
import { type NotificationResponse } from "@vega-api/generated/types/notificationResponse";

import { subscribeNotificationEvent } from "./notificationEventBus";

export const useNotificationEvent = (
  type: NotificationContentType,
  handler: (payload: NotificationResponse) => void,
) => {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(
    () =>
      subscribeNotificationEvent(type, (payload) => {
        handlerRef.current(payload);
      }),
    [type],
  );
};
